import { Inject, Injectable, Injector }from '@angular/core';

import { Utilities_DatasourceService } from './Utilities.datasource.index';

import { Cartonization_ds_cartonization_strategies_ddService } from './Cartonization.datasource.index';
import { Cartonization_ds_get_cartonization_workflowsService } from './Cartonization.datasource.index';
import { Cartonization_ds_get_completed_picking_tasks_by_shipmentIdService } from './Cartonization.datasource.index';
import { Cartonization_ds_get_container_typesService } from './Cartonization.datasource.index';
import { Cartonization_ds_get_material_packaging_by_materialIdsService } from './Cartonization.datasource.index';
import { Cartonization_ds_get_max_shipment_line_number_by_shipmentIdService } from './Cartonization.datasource.index';
import { Cartonization_ds_get_picking_tasks_by_shipmentIdService } from './Cartonization.datasource.index';
import { Cartonization_ds_get_shipment_lines_by_shipmentIdService } from './Cartonization.datasource.index';
import { Cartonization_ds_get_shipping_containers_by_shipmentIdService } from './Cartonization.datasource.index';
import { Cartonization_ds_get_shipping_containers_to_removeService } from './Cartonization.datasource.index';

@Injectable({ providedIn: 'root' })
export class Cartonization_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_DatasourceService);
  }

    public Utilities: Utilities_DatasourceService;
  public Cartonization: Cartonization_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _ds_cartonization_strategies_dd: Cartonization_ds_cartonization_strategies_ddService;
  public get ds_cartonization_strategies_dd(): Cartonization_ds_cartonization_strategies_ddService {
    if(!this._ds_cartonization_strategies_dd) {
      this._ds_cartonization_strategies_dd = this.injector.get(Cartonization_ds_cartonization_strategies_ddService);
    }
    return this._ds_cartonization_strategies_dd;
  }
  private _ds_get_cartonization_workflows: Cartonization_ds_get_cartonization_workflowsService;
  public get ds_get_cartonization_workflows(): Cartonization_ds_get_cartonization_workflowsService {
    if(!this._ds_get_cartonization_workflows) {
      this._ds_get_cartonization_workflows = this.injector.get(Cartonization_ds_get_cartonization_workflowsService);
    }
    return this._ds_get_cartonization_workflows;
  }
  private _ds_get_completed_picking_tasks_by_shipmentId: Cartonization_ds_get_completed_picking_tasks_by_shipmentIdService;
  public get ds_get_completed_picking_tasks_by_shipmentId(): Cartonization_ds_get_completed_picking_tasks_by_shipmentIdService {
    if(!this._ds_get_completed_picking_tasks_by_shipmentId) {
      this._ds_get_completed_picking_tasks_by_shipmentId = this.injector.get(Cartonization_ds_get_completed_picking_tasks_by_shipmentIdService);
    }
    return this._ds_get_completed_picking_tasks_by_shipmentId;
  }
  private _ds_get_container_types: Cartonization_ds_get_container_typesService;
  public get ds_get_container_types(): Cartonization_ds_get_container_typesService {
    if(!this._ds_get_container_types) {
      this._ds_get_container_types = this.injector.get(Cartonization_ds_get_container_typesService);
    }
    return this._ds_get_container_types;
  }
  private _ds_get_material_packaging_by_materialIds: Cartonization_ds_get_material_packaging_by_materialIdsService;
  public get ds_get_material_packaging_by_materialIds(): Cartonization_ds_get_material_packaging_by_materialIdsService {
    if(!this._ds_get_material_packaging_by_materialIds) {
      this._ds_get_material_packaging_by_materialIds = this.injector.get(Cartonization_ds_get_material_packaging_by_materialIdsService);
    }
    return this._ds_get_material_packaging_by_materialIds;
  }
  private _ds_get_max_shipment_line_number_by_shipmentId: Cartonization_ds_get_max_shipment_line_number_by_shipmentIdService;
  public get ds_get_max_shipment_line_number_by_shipmentId(): Cartonization_ds_get_max_shipment_line_number_by_shipmentIdService {
    if(!this._ds_get_max_shipment_line_number_by_shipmentId) {
      this._ds_get_max_shipment_line_number_by_shipmentId = this.injector.get(Cartonization_ds_get_max_shipment_line_number_by_shipmentIdService);
    }
    return this._ds_get_max_shipment_line_number_by_shipmentId;
  }
  private _ds_get_picking_tasks_by_shipmentId: Cartonization_ds_get_picking_tasks_by_shipmentIdService;
  public get ds_get_picking_tasks_by_shipmentId(): Cartonization_ds_get_picking_tasks_by_shipmentIdService {
    if(!this._ds_get_picking_tasks_by_shipmentId) {
      this._ds_get_picking_tasks_by_shipmentId = this.injector.get(Cartonization_ds_get_picking_tasks_by_shipmentIdService);
    }
    return this._ds_get_picking_tasks_by_shipmentId;
  }
  private _ds_get_shipment_lines_by_shipmentId: Cartonization_ds_get_shipment_lines_by_shipmentIdService;
  public get ds_get_shipment_lines_by_shipmentId(): Cartonization_ds_get_shipment_lines_by_shipmentIdService {
    if(!this._ds_get_shipment_lines_by_shipmentId) {
      this._ds_get_shipment_lines_by_shipmentId = this.injector.get(Cartonization_ds_get_shipment_lines_by_shipmentIdService);
    }
    return this._ds_get_shipment_lines_by_shipmentId;
  }
  private _ds_get_shipping_containers_by_shipmentId: Cartonization_ds_get_shipping_containers_by_shipmentIdService;
  public get ds_get_shipping_containers_by_shipmentId(): Cartonization_ds_get_shipping_containers_by_shipmentIdService {
    if(!this._ds_get_shipping_containers_by_shipmentId) {
      this._ds_get_shipping_containers_by_shipmentId = this.injector.get(Cartonization_ds_get_shipping_containers_by_shipmentIdService);
    }
    return this._ds_get_shipping_containers_by_shipmentId;
  }
  private _ds_get_shipping_containers_to_remove: Cartonization_ds_get_shipping_containers_to_removeService;
  public get ds_get_shipping_containers_to_remove(): Cartonization_ds_get_shipping_containers_to_removeService {
    if(!this._ds_get_shipping_containers_to_remove) {
      this._ds_get_shipping_containers_to_remove = this.injector.get(Cartonization_ds_get_shipping_containers_to_removeService);
    }
    return this._ds_get_shipping_containers_to_remove;
  }
}

